<template>
  <div>
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="appointmentOrders">
      <div slot="toolbar">
        <el-button type="primary" @click="$refs.editPage.open(0)">新建</el-button>
        <el-button type="primary" :loading="exportLoading" @click="exportExcel()">导出</el-button>
      </div>
      <template slot="adSearch">
        <vm-search label="登记日期">
          <div class="block">
            <el-date-picker
                v-model="filter.beginCreateTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="date"
                style="width: 190px"
                placeholder="选择开始日期"/>
          </div>
        </vm-search>
        <vm-search label="至">
          <div class="block">
            <el-date-picker
                v-model="filter.endCreateTime"
                value-format="yyyy-MM-dd 23:59:59"
                type="date"
                style="width: 190px"
                placeholder="选择结束日期"/>
          </div>
        </vm-search>
        <vm-search label="单号">
          <el-input v-model.trim="filter.billNo" clearable/>
        </vm-search>
        <vm-search label="出厂编号">
          <el-input v-model.trim="filter.factoryNo" clearable/>
        </vm-search>
        <vm-search label="销售员">
          <el-input v-model.trim="filter.salesmanName" clearable/>
        </vm-search>
        <vm-search label="客户名称">
          <el-input v-model.trim="filter.customerName" clearable/>
        </vm-search>
        <vm-search label="登记人">
          <el-input v-model.trim="filter.creatorName" clearable/>
        </vm-search>
        <vm-search label="服务地点">
          <el-input v-model.trim="filter.serviceAddress" clearable/>
        </vm-search>
        <vm-search label="现场联系人">
          <el-input v-model.trim="filter.contact" clearable/>
        </vm-search>
        <vm-search label="现场联系方式">
          <el-input v-model.trim="filter.siteMobile" clearable/>
        </vm-search>
        <vm-search label="流程状态">
          <el-select v-model.trim="filter.status" clearable placeholder="请选择流程状态">
            <el-option label="草稿" :value="0"/>
            <el-option label="待售后审核" :value="10"/>
            <el-option label="待售后主管审核" :value="20"/>
            <el-option label="待现场支持" :value="30"/>
            <el-option label="待报价处理" :value="40"/>
            <el-option label="待费用确认" :value="50"/>
            <el-option label="已结束" :value="60"/>
          </el-select>
        </vm-search>
        <vm-search label="现场处理人员">
          <el-input v-model.trim="filter.siteHandler" clearable/>
        </vm-search>
        <vm-search label="售后主管">
          <el-input v-model.trim="filter.managerApproveName" clearable/>
        </vm-search>
      </template>
      <el-table-column
          fixed="left"
          prop="billNo"
          width="140"
          align="center"
          label="预约单号">
        <template slot-scope="scope">
          <span style="color: #2d8cf0; cursor: pointer" @click="goto(scope.row)">{{scope.row.billNo}}</span>
          <el-button
              v-clipboard="scope.row.billNo"
              v-clipboard:success="clipboardSuccessHandler"
              v-clipboard:error="clipboardErrorHandler"
              round
              icon="el-icon-chat-line-square"/>
        </template>
      </el-table-column>
      <el-table-column
          fixed="left"
          prop="factoryNo"
          width="120"
          align="center"
          label="出厂编号"/>
      <el-table-column prop="creatTime" width="180" align="center" label="登记日期"/>
      <el-table-column prop="customerName" width="200" align="center" label="客户名称"/>
      <el-table-column prop="serviceAddress" width="280" align="center" label="服务地点"/>
      <el-table-column prop="contact" width="130" align="center" label="现场联系人"/>
      <el-table-column prop="siteMobile" width="120" align="center" label="联系方式"/>
      <el-table-column prop="salesmanName" align="center" label="销售员"/>
      <el-table-column prop="dataSources" align="center" label="数据来源">
        <template scope="scope">
          <span v-if="scope.row.dataSources === '电梯云'">{{scope.row.dataSources}}</span>
          <span v-else>EMES</span>
        </template>
      </el-table-column>
      <el-table-column prop="nodeDesc" align="center" label="流程状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 60">已完成</span>
          <span v-else-if="scope.row.nodeDesc===null && scope.row.status>0">已完成</span>
          <span v-else>{{scope.row.nodeDesc}}</span>
        </template>
      </el-table-column>
      <!--      <el-table-column fixed="right" width="130" prop="status" align="center" label="进度">-->
      <!--        <template scope="scope">-->
      <!--          <span v-if="scope.row.status===0">草稿</span>-->
      <!--          <span v-else-if="scope.row.status===10">待售后审核</span>-->
      <!--          <span v-else-if="scope.row.status===20">待售后主管审核</span>-->
      <!--          <span v-else-if="scope.row.status===30">待现场支持</span>-->
      <!--          <span v-else-if="scope.row.status===31">待质量调查</span>-->
      <!--          <span v-else-if="scope.row.status===40">待报价处理</span>-->
      <!--          <span v-else-if="scope.row.status===50">待费用确认</span>-->
      <!--          <span v-else-if="scope.row.status===60">已结束</span>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate"
          fixed="right"
          width="120px">
        <template slot-scope="scope">
          <el-button v-if="scope.row.status===0 || editAuth" type="primary" @click="$refs.editPage.open(scope.row)">编辑</el-button>
          <el-button v-if="scope.row.status===0" type="primary" @click="submit(scope.row.pkid)">提交</el-button>
          <el-button v-if="scope.row.status===0" type="danger" @click="oneDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <appointment-edit ref="editPage" @save-success="getList(1)"/>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import AppointmentEdit from "@/views/afterSalesManagement/Appointment/AppointmentEdit";
  export default {
    name: "",
    components: {AppointmentEdit, VmTable,VmSearch},
    data() {
      return {
        idList: "",
        editAuth: this.$auth(895),
        exportLoading: false,
        filter: {
          billNo: "",
          factoryNo: "",
          salesmanName: "",
          customerName: "",
          creatorName: "",
          serviceAddress: "",
          contact: "",
          siteMobile: "",
          status: "",
          siteHandler: "",
          managerApproveName: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      submit(pkid) {
        this.$confirm("确定提交吗?", "提示", { type: "warning" }).then(() => {
          this.$http.get("basic", "appointmentOrders/submit/" + pkid).then(() => {
            this.$message.success("操作成功");
            this.getList(-1);
          });
        });
      },
      clipboardSuccessHandler(e) {
        this.$message.success("复制单号成功");
      },
      clipboardErrorHandler(e) {
        this.$message.error("复制单号失败");
      },
      goto(row) {
        this.$router.push({
          path: "/Appointment",
          query: {
            billType: 15,
            billId: row.pkid,
            $tabName: row.billNo,
          },
        });
      },
      //导出
      exportExcel() {
        this.exportLoading = true;
        console.log(this.filter);
        this.$http
          .exportFile("basic","appointmentOrders/export", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
      // 单项删除
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","appointmentOrders",row.pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
    },
  };
</script>

<style scoped>

</style>
